
export function getTopImage(id){
    switch(id){
      case "1": return "nezzuk_kiserletek_thumbnail_web_leander-min.jpg"; 
      case "2": return "nezzuk_kiserletek_thumbnail_web_petrezselyem-min.jpg"; 
      case "3": return "nezzuk_kiserletek_thumbnail_web_tiszafa-min.jpg"; 
      case "4": return "nezzuk_kiserletek_thumbnail_web_foliassalata-min.jpg"; 
      case "5": return "nezzuk_kiserletek_thumbnail_web_srepa-min.jpg"; 
      case "6": return "nezzuk_kiserletek_thumbnail_web_leandervirag-min.jpg"; 
      case "7": return "nezzuk_kiserletek_thumbnail_web_fukomposzt-min.jpg"; 
      case "8": return "nezzuk_kiserletek2_thumbnail_cukkini.jpg"; 
      case "12": return "nezzuk_kiserletek2_thumbnail_feherpaprika.jpg";
      case "15": return "nezzuk_kiserletek2_thumbnail_kapiapaprika.jpg";
      case "16": return "nezzuk_kiserletek2_thumbnail_paprika-amazon.jpg";
      case "17": return "nezzuk_kiserletek2_thumbnail_koktelparadicsom.jpg";
      case "18": return "nezzuk_kiserletek2_thumbnail_marmade.jpg";
      case "19": return "nezzuk_kiserletek2_thumbnail_paradicsom-amazon.jpg";
      case "20": return "nezzuk_kiserletek2_thumbnail_disznoveny.jpg";
      case "21": return "nezzuk_kiserletek2_thumbnail_gyumolcsos.jpg";
      case "22": return "nezzuk_kiserletek2_thumbnail_vetemenyes.jpg";
      default: return "test";
    }
}

export function getShieldImgSrc(id){
    return "img/kwizda3_cimkek/" + getTopImage(id);
}

export function gethelperImgSrc(id){
    switch (id){
        case "12": return "img/kwizda3_fotoseged/web_paprika_both.jpg";
        case "15": return "img/kwizda3_fotoseged/web_paprika_both.jpg";
        case "16": return "img/kwizda3_fotoseged/web_paprika_both.jpg";
        case "17": return "img/kwizda3_fotoseged/web_paradicsom_both.jpg";
        case "18": return "img/kwizda3_fotoseged/web_paradicsom_both.jpg";
        case "19": return "img/kwizda3_fotoseged/web_paradicsom_both.jpg";
    }
}

